<template>
  <div>
    <com-page>
      <com-search :columns="searchColumn" @search="handleSearch"></com-search>
      <com-card class="mt-15px">
        <com-table ref="table" :api="api" :columns="columns">
          <template #created="{ data }">
            {{ data.createTime | timeFormate }}
          </template>
        </com-table>
      </com-card>
    </com-page>
  </div>
</template>

<script>
import { virtualRechargeOrderList } from '@/api/order'

export default {
  data() {
    return {
      api: virtualRechargeOrderList,
      searchColumn: [
        {
          label: '用户ID/手机号',
          prop: 'queryUserCondition',
          type: 'input'
        },
        {
          label: '订单编号',
          prop: 'number',
          type: 'input'
        },
        {
          label: '时间范围',
          prop: 'date',
          type: 'date'
        }
      ],
      columns: [
        {
          label: '订单编号',
          prop: 'number'
        },
        {
          label: '充值金额',
          prop: 'sum'
        },
        {
          label: '充值原因',
          prop: 'reason'
        },
        {
          label: '用户ID',
          prop: 'refUserNumber'
        },
        {
          label: '手机号',
          prop: 'refUserPhone'
        },
        {
          label: '充值时间',
          prop: 'created',
          type: 'slot',
          slotName: 'created'
        }
      ],
      query: {}
    }
  },
  methods: {
    handleSearch(val) {
      this.query = val
      this.$refs.table.search(val)
    },
  }
}
</script>

<style lang="scss" scoped></style>
